import { AlertTriangleIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import {
	Empty,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
} from '@/shared/components/ui/empty'

export function SalesFactorsImpactWidgetErrorState() {
	const { t } = useTranslation()

	return (
		<Empty>
			<EmptyHeader>
				<EmptyMedia variant='icon'>
					<AlertTriangleIcon />
				</EmptyMedia>
				<EmptyDescription>{t('error.unrecoverable.title')}</EmptyDescription>
			</EmptyHeader>
		</Empty>
	)
}
